// HM-307: definizione voci sidebar SPEC v2.6.
// HM-321 cluster 15.5: aggiunta voce "Camere" come 2a (dopo Dashboard,
// prima Planning) con icona BedDouble - separa la lista mappa camere
// dalla pagina informativa Dashboard.
// Ogni voce ha id stabile, label, href della route React Router e icona.

import type { SidebarItem } from '@hotel-manager/ui';
import {
  BedDouble,
  BookOpenCheck,
  CalendarDays,
  Cpu,
  FileText,
  LayoutDashboard,
  Settings2,
  TrendingUp,
  Users,
  UtensilsCrossed,
  Wallet,
  Wrench,
} from '@hotel-manager/ui/icons';

export const sidebarItems: SidebarItem[] = [
  { id: 'dashboard', label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { id: 'camere', label: 'Camere', href: '/camere', icon: BedDouble },
  { id: 'planning', label: 'Planning', href: '/planning', icon: CalendarDays },
  { id: 'prenotazioni', label: 'Prenotazioni', href: '/prenotazioni', icon: BookOpenCheck },
  { id: 'ospiti', label: 'Ospiti', href: '/ospiti', icon: Users },
  { id: 'alloggiati', label: 'Alloggiati', href: '/alloggiati', icon: FileText },
  { id: 'cassa', label: 'Cassa', href: '/cassa', icon: Wallet },
  { id: 'report', label: 'Report', href: '/report', icon: TrendingUp },
  { id: 'room-service', label: 'Room Service', href: '/room-service', icon: UtensilsCrossed },
  { id: 'manutenzione', label: 'Manutenzione', href: '/manutenzione', icon: Wrench },
  { id: 'knx', label: 'KNX & Automazioni', href: '/knx', icon: Cpu },
  { id: 'impostazioni', label: 'Impostazioni', href: '/impostazioni', icon: Settings2 },
];
